<template>
  <div class="product_list__table" v-if="labProducts">
    <!-- lab test product details -->
    <vs-table :data="labProducts" class="vs-con-loading__container mt-8 border border-solid">
      <template slot="thead">
        <vs-th>Item Name</vs-th>
        <vs-th>Price</vs-th>
        <vs-th>Quantity</vs-th>
        <vs-th>SubTotal</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>{{ tr.product_name }}</vs-td>

          <vs-td>$ {{ tr.price | currencyFilter }}</vs-td>

          <vs-td>
            <vs-input type="number" v-if="step === 2" :value="tr.quantity" :min="0" :max-decimal="0" @input="validateQty(tr, $event)" class="inputx" />
            <span v-else>{{ tr.quantity | weightFilter }}</span>
          </vs-td>

          <vs-td>$ {{ renderSubTotal(tr) | currencyFilter }}</vs-td>
        </vs-tr>

        <vs-tr class="border-0 border-t-2 border-solid border-black">
          <vs-td colspan="3">Total</vs-td>
          <vs-td>$ {{ grand_total | currencyFilter }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { paymentMixins } from '@/utils/paymentTypes'
import { weightMixins } from '@/utils/weightType'

export default {
  name: 'ProductListTable',

  props: {
    step: Number
  },

  mixins: [paymentMixins, weightMixins],

  computed: {
    ...mapState('lab', ['labProducts']),

    renderSubTotal() {
      return item => {
        return item.price * Number(item.quantity)
      }
    },

    grand_total() {
      return this.labProducts.reduce((acc, item) => {
        acc += item.price * Number(item.quantity)
        return acc
      }, 0)
    }
  },
  methods: {
    ...mapMutations('lab', { updateLabProducts: 'UPDATE_LAB_PRODUCTS' }),

    // validate weight types - and increase quantity
    async validateQty(tr, value) {
      const val = Math.round(Math.abs(value))
      this.updateLabProducts({ key: 'id', value: tr.id, field: 'quantity', data: val })
    }
  },
  // filters
  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    },

    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(Number(value), 3)
    }
  }
}
</script>

<style></style>
